<script>import { Button } from "@infinitro/button";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { CheckIcon, RemoveIcon } from "@infinitro/icons";
import { Input } from "@infinitro/input";
import {
  disconnect,
  stateConnectedWalletAddress,
  stateConnectedWalletSigned
} from "@infinitro/wallet_verify";
import { onSign as onClick } from "../state";
$: useExpandedRankPresentation = $stateUi.layout?.useExpandedRankPresentation ?? false;
const onRemove = (event) => {
  event?.preventDefault();
  event?.stopPropagation();
  disconnect();
};
</script>

<span class="section">
	<div class="input">
		<Input
			type="text"
			name="email"
			id="wallet"
			required={true}
			disabled={true}
			value={$stateConnectedWalletAddress}
		/>
		{#if $stateConnectedWalletAddress}<span class="trailing-icon"
				><button type="button" class="remove" on:click={onRemove}><RemoveIcon /></button><span
					class="check"><CheckIcon /></span
				></span
			>{/if}
	</div>
	{#if !$stateConnectedWalletSigned}
		<div class="verify-container">
			<Button
				className={useExpandedRankPresentation ? 'enable-verify-alternative' : ''}
				variant="secondary"
				text={$t(Verbiage.sign)}
				{onClick}
				disabled={!stateConnectedWalletAddress}
				styleCustom="height: 48px; min-width: 100px;"
				id="verifyButton"
			/>
		</div>
	{/if}
</span>

<style>
	.section {
		display: flex;
		align-items: center;
		gap: 0.25rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
}

	div.input {
		position: relative;
		display: flex;
		height: 48px;
		width: 100%;
		align-items: center;
		white-space: nowrap;
}

	div.verify-container {
		position: relative;
}

	.trailing-icon {
		pointer-events: auto;
		position: absolute;
		top: 4px;
		right: 0px;
		display: flex;
		padding-right: 0.5rem;
}

	.check {
		position: absolute;
		top: 14px;
}

	.remove {
		cursor: pointer;
}

	input,
	input:disabled {
		display: block;
		height: 48px;
		width: 100%;
		border-radius: 16px;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		padding-left: 1rem;
		padding-right: 1rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity));
		background: var(--gradient-alternative-4);
}

	input:focus {
		display: block;
		width: 100%;
		border-radius: 16px;
		border-width: 1px;
		background-color: var(--color-background-100);
		padding: 1rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity));
		outline: 2px solid transparent;
		outline-offset: 2px;
}

	input:hover {
		background: var(--gradient-main);
}

	input:active {
		background: var(--gradient-main);
}

	input:focus-within {
		border-color: var(--color-secondary-500);
}

	.input-alternative:hover,
	.input-alternative:active,
	.input-alternative:focus,
	.input-alternative {
		background-image: unset;
	}

	input:-webkit-autofill {
		--tw-text-opacity: 1 !important;
		color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
		background: var(--gradient-main) !important;
		background-color: transparent !important;
}

	input:-webkit-autofill,
	input:autofill,
	input:-internal-autofill-selected {
		--tw-text-opacity: 1 !important;
		color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
		background: var(--gradient-main) !important;
		background-color: transparent !important;
}

	input:-webkit-autofill:focus {
		border-color: var(--color-secondary-500);
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity));
		background: var(--gradient-main);
}

	input:-webkit-autofill:focus,
	input:autofill:focus {
		border-color: var(--color-secondary-500);
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity));
		background: var(--gradient-main);
}
</style>
